import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Grid from "@mui/material/Grid";
import { useState } from "react";
import { DotsThree, CaretDoubleUp } from "@phosphor-icons/react";
const RightMessage = ({ message, name, date, maxCharacters, }) => {
    const [showFullText, setShowFullText] = useState(false);
    const toggleTextVisibility = () => {
        setShowFullText(!showFullText);
    };
    const truncatedText = showFullText
        ? message
        : message.slice(0, maxCharacters);
    return (_jsxs(Grid, { container: true, size: 12, className: "rightmessage", children: [_jsx(Grid, { size: 2, children: _jsx(Avatar, {}) }), _jsxs(Grid, { container: true, size: 12, className: "content", children: [_jsxs(Grid, { className: "namecontainer", children: [_jsx(Typography, { className: "nametext", children: name }), _jsx(Typography, { className: "datetext", children: date })] }), _jsx(Grid, { children: _jsx(Typography, { className: "message", children: truncatedText }) }), message.length > maxCharacters &&
                        (showFullText ? (_jsx(CaretDoubleUp, { onClick: toggleTextVisibility, children: " " })) : (_jsx(DotsThree, { onClick: toggleTextVisibility })))] })] }));
};
export default RightMessage;
